import { Show, TabbedShowLayout, Tab, EditButton, TopToolbar } from "react-admin";
import { CustomerFields } from "../customer/customer-fields";
import { DriverFields } from "../driver/driver-fields";

export const AdminUserPropsShow:React.FC = (props: any) => {
  const PostShowActions = ( data: any ) => {
    const type = props ? props.location.pathname.split('/').pop() : 'profiles';
    const editPath = `/${type}/${data.data.id}`;
    return(
      <TopToolbar>
        <EditButton to={{pathname: editPath}} record={data} />
      </TopToolbar>
    )
  };
  const Tabs = () => {
    return(
      <TabbedShowLayout>
        <Tab label="Customer" path="profiles">
          <CustomerFields />
        </Tab>
        <Tab label="Driver" path="drivers">
          <DriverFields  />
        </Tab>
          
      </TabbedShowLayout>
    )}
  return(
    <Show {...props} actions={<PostShowActions />}>
      <Tabs />
    </Show>
  )};